// Global client-side error reporting (ops bundle). Errors and unhandled
// promise rejections POST to /client-errors, where they land in the same
// deduped sink as server errors (Admin -> Errors). Per-session dedup + a hard
// cap so a render loop can't hammer the endpoint.
const seen = new Set();

function post(payload) {
  try {
    fetch("/client-errors", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* never let reporting throw */ }
}

export function reportError(name, message, stack) {
  try {
    const key = String(name) + "|" + String(message).slice(0, 120);
    if (seen.has(key) || seen.size >= 20) return;
    seen.add(key);
    post({
      name: String(name || "Error").slice(0, 180),
      message: String(message || "").slice(0, 1800),
      stack: String(stack || "").slice(0, 7000),
      path: window.location.pathname + window.location.search,
    });
  } catch (e) { /* ignore */ }
}

export function initErrorReporting() {
  if (window.__tm3ErrInit) return;
  window.__tm3ErrInit = true;
  window.addEventListener("error", (e) => {
    const err = e.error;
    reportError((err && err.name) || "Error", e.message || String(err || "unknown"), err && err.stack);
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    reportError((r && r.name) || "UnhandledRejection", (r && r.message) || String(r), r && r.stack);
  });
}
